import { render } from "./PersonPicker.vue?vue&type=template&id=2764c247&scoped=true&ts=true"
import script from "./PersonPicker.vue?vue&type=script&lang=ts"
export * from "./PersonPicker.vue?vue&type=script&lang=ts"

import "./PersonPicker.vue?vue&type=style&index=0&id=2764c247&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2764c247"]])

export default __exports__